export default {
  // Endpoints
  userGroupCreateEndpoint: 'https://self-service-api.revenue.co.ke/api/v1/user-groups/create',
}
